// extracted by mini-css-extract-plugin
export default {"zoomControls":"Waa-z","zoomControlButton":"Xaa-z","zoomBanner":"Yaa-z","bannerButton":"Zaa-z","imageButton":"_aa-z","zoom":"aba-z","zoomContent":"bba-z"};